import React from 'react';
import {
  ComponentProps,
  CriticalButton as GjensidigeCriticalButton
} from '@gjensidige/core-buttons/lib/critical-button';
import { PrimaryButton as GjensidigePrimaryButton } from '@gjensidige/core-buttons/lib/primary-button';
import {
  ComponentProps as SecondaryButtonProps,
  SecondaryButton as GjensidigeSecondaryButton
} from '@gjensidige/core-buttons/lib/secondary-button';

import { mergeClassNames } from '../utils';
import styles from './Button.module.scss';

const classNames = (optionalClassName?: string) => {
  return mergeClassNames(styles.button, optionalClassName);
};

export const CriticalButton = ({
  children,
  className,
  ...rest
}: ComponentProps) => {
  return (
    <GjensidigeCriticalButton
      enableTracking={false}
      color="orange"
      className={classNames(className)}
      {...rest}
    >
      {children}
    </GjensidigeCriticalButton>
  );
};

export const PrimaryButton = ({
  children,
  className,
  ...rest
}: ComponentProps) => {
  return (
    <GjensidigePrimaryButton
      className={classNames(className)}
      enableTracking={false}
      {...rest}
    >
      {children}
    </GjensidigePrimaryButton>
  );
};

export const SecondaryButton = ({
  children,
  className,
  ...rest
}: SecondaryButtonProps) => {
  return (
    <GjensidigeSecondaryButton
      className={className}
      enableTracking={false}
      {...rest}
    >
      {children}
    </GjensidigeSecondaryButton>
  );
};
